import { render, staticRenderFns } from "./SupplierDocumentList.vue?vue&type=template&id=10a70938&scoped=true&"
import script from "./SupplierDocumentList.vue?vue&type=script&lang=js&"
export * from "./SupplierDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDocumentList.vue?vue&type=style&index=0&id=10a70938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a70938",
  null
  
)

export default component.exports